import * as utility from "./services.js"
import * as datasources from "./common_metadata/datasource.js"
import { ResizeDetector } from "./resize_detector.js";
import { Dialog, DialogProps } from "../core/components/dialog.js";
import { FullHeightContainer } from "../core/components/FullHeighContainer.js";
import { MonacoEditor } from "../core/components/monacoEditor.js";
import { Helper } from "../core/util/helper.js";
import { Button } from "../core/components/button.js";
import React from "react";
export class ReactDynamicRow extends React.Component<any, any>{
    handleTextChange = (name, value) => {
        this.props.onTextChange(name, value);
    }

    renderComponents = (component, propertyName, index) => {
        var newPropertyPath = this.props.rootPropertyPath.slice();
        newPropertyPath.push(propertyName);
        newPropertyPath.push(index);

        var compObj = utility.getComponentBySettings(component, this.props.values, this, this.props.queryParameter, this.props.context, newPropertyPath, this.props.extendedUid);

        if (compObj) {
            return compObj;
        }
    }

    render() {
        if (Array.isArray(this.props.settings.rowItems)) {
            var that = this;
            var i = 0;
            var comps = this.props.settings.rowItems.map(function (component) { return that.renderComponents(component, 'rowItems', i++) });
        }

        const style: React.CSSProperties = this.props.context?.fullHeightLayout ? { height: "100%" } : { display: "grid", gridTemplateColumns: "repeat(12,1fr)", gridTemplateRows: "max-content" };

        return (<div style={style} className="row">
            {comps}
        </div>
        );
    }
};

interface IColumn extends React.PropsWithChildren {
    width: number,
    height?: string
}
export class ReactColumn extends React.Component<IColumn, any>{
    render() {
        const style: React.CSSProperties = { gridColumn: "span " + (this.props.width || "12") };
        if (this.props.height) {
            style.height = this.props.height;
        }
        return (<div style={style} >
            {this.props.children}
        </div>
        );
    }
};

export class ReactTextArea extends React.Component<any, any>{
    constructor(props) {
        super(props);
    }

    handleChange = (event) => {
        this.props.onTextChange(event.target.value);
    }

    render() {
        var classString = 'form-group';
        var value = this.props.value || null;;

        if (this.props.settings.isMandatory) {
            classString += ' required';
        }
        var style: React.CSSProperties = { height: '500px', resize: 'none' };

        return (
            <ReactColumn width={this.props.settings.width}>
                <div className={classString}>
                    <label>{this.props.settings.label}</label>
                    <textarea value={value} className="form-control" onChange={this.handleChange} style={style}></textarea>
                </div>
            </ReactColumn>
        );
    }
};

export class ReactBox extends React.Component<any, any>{
    render() {
        return (
            <ReactColumn width={this.props.width}>
                <div className="box box-primary" >
                    <div style={{ color: "#fff", background: "#3c8dbc", backgroundColor: "#777" }}>
                        <h3 style={{ padding: "10px 0px 10px 10px", margin: "0px", display: "inline-block", color: "white", fontSize: "16px", fontWeight: 400 }}>{this.props.header}</h3>
                    </div>
                    <div className="box-body" >{this.props.children}</div>
                </div>
            </ReactColumn>
        );

    }
};



export class ReactBoxFooter extends React.Component<any, any>{
    render() {
        return (
            <div className="box-footer">
                {this.props.children}
            </div>
        );
    }
};

export interface IDynamicUiProps {
    uiId?: number;
    uiDefinition: any;
    parameters: any;
    contextVariables?: any;
    onTextChange(property, value);
    queryParameter?: any;
    context?: any;
};

export class ReactDynamicUi extends React.Component<IDynamicUiProps, any> {
    constructor(props) {
        super(props);
        var state: any;
        state = { data: props.uiDefinition, uiValues: props.parameters || {} };
        this.state = state;
    }

    UNSAFE_componentWillReceiveProps(nextProps: IDynamicUiProps) {
        this.setState({ data: nextProps.uiDefinition, uiValues: nextProps.parameters || {} });
    }

    handleTextChange = (name, value) => {
        this.props.onTextChange(name, value);
    }

    buildComponents = (component, values, propertyName, index) => {

        var propertyPath = [propertyName, index];

        var compObj = utility.getComponentBySettings(component, values, this, this.props.queryParameter, this.props.context, propertyPath, "");

        if (compObj) {
            return compObj;
        }
    }

    createRows = (rows, propertyName) => {
        var that = this;
        var values = that.state.uiValues || {};
        if (!rows) {
            return null;
        }
        var i = 0;
        return rows.map(function (row) {
            return that.buildComponents(row, values, propertyName, i++);
        });
    }

    buildUi = () => {
        if (this.state.data) {

            return this.createRows(this.state.data.rows, 'rows');
        }
        return <div>...</div>
    }

    render() {
        let busyIndicator = null;
        if (this.state.isLoading === true) {
            busyIndicator = <BusyIndicator contextVariables={this.props.contextVariables} />;

        }
        return (
            <>
                {this.buildUi()}
                {busyIndicator}</>
        );
    }
};

export const BusyIndicator = ({ contextVariables }) => {
    return (
        <div className="modal fade show in">
            <div style={{ display: "table", height: "100%", width: "100%" }}>
                <div className="modal-dialog" style={{ display: "table-cell", verticalAlign: "middle" }}>
                    <div className="modal-content" style={{ margin: "auto", width: "250px" }}>
                        <div className="modal-header">
                            <img style={{ display: "block", marginLeft: "auto", marginRight: "auto" }} src={contextVariables["INNO_BASE_PATH"] + "Statistics/Content/img/loading-image.gif"}></img>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
};

export class ReactDataPager extends React.Component<any, any>{
    max_page_size: number = 100000;
    dataSourceId: string;

    constructor(props) {
        super(props);
        this.state = { page: 0 };
    }

    handleDataChanged = (allData) => {

        let primaryResult = allData[(this.props.dataSource ? this.props.dataSource.getDataSourceIdentifier() : this.props.dataUrl) + this.props.uid];
        if (!primaryResult) {
            primaryResult = allData[(this.props.dataSource ? this.props.dataSource.getDataSourceIdentifier() : this.props.dataUrl)];
        }

        if (primaryResult && primaryResult.Data) {
            let visibleValues;
            let data;
            let pivotKeys;

            if (this.props.pivotProperties) {
                let pivotized = utility.StatisticHelper.pivoteData(this.props.pivotProperties, primaryResult.Data);
                data = pivotized.pivotizedData;
                pivotKeys = pivotized.pivotKeys;
            } else {
                data = primaryResult.Data
            }

            if (this.props.enablePagging === true) {
                var ps = this.props.pageSize || this.max_page_size;
                visibleValues = data.slice(0, ps);
            }
            else {
                visibleValues = data;
            }

            this.setState({ allValues: data, visibleValues: visibleValues, page: 0, pivotKeys: pivotKeys });
            this.props.onVisibleDataChange(visibleValues, pivotKeys, primaryResult.Metadata, data);
        }
    }

    componentDidMount() {
        this.dataSourceId = this.getDataSourceIdFromProps(this.props);

        if (this.dataSourceId) {
            this.registerComponent(this.props.uid, [this.props.dataUrl], Array.isArray(this.props.dataSource) ? this.props.dataSource : [this.props.dataSource]);
        }
    }

    componentWillUnmount() {
        this.props.context.unregisterComponent(this.props.uid);
    }

    getVisibleData = (data, page) => {
        if (!data) {
            return [];
        }
        let visibleValues;
        if (this.props.pageSize) {
            var ps = this.props.pageSize || this.max_page_size;
            visibleValues = data.slice(page * ps, page * ps + ps)
        }
        else {
            visibleValues = data;
        }

        return visibleValues
    }

    handlePrefClicked = () => {
        var data = this.getVisibleData(this.state.allValues, this.state.page - 1);
        this.setState({ visibleValues: data, page: this.state.page - 1 });
        this.props.onVisibleDataChange(data, this.state.pivotKeys, null, this.state.allValues);
    }

    handleNextClicked = () => {
        this.setState({});
        var data = this.getVisibleData(this.state.allValues, this.state.page + 1);
        this.setState({ visibleValues: data, page: this.state.page + 1 });
        this.props.onVisibleDataChange(data, this.state.pivotKeys, null, this.state.allValues);
    }

    hasMoreElements = () => {

        var pageSize = this.props.pageSize || this.max_page_size;
        var rowCount = (this.state.allValues || []).length;
        return rowCount > pageSize * (this.state.page + 1);
    }

    registerComponent = (uid: string, services: string[], datasources: datasources.Datasource[]) => {
        this.props.context.registerComponent(uid, services, this.handleDataChanged, null, datasources);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let newDataSourceId: string = this.getDataSourceIdFromProps(nextProps);

        if (newDataSourceId != this.dataSourceId) {
            this.dataSourceId = newDataSourceId;
            this.registerComponent(this.props.uid, [nextProps.dataUrl], Array.isArray(nextProps.dataSource) ? nextProps.dataSource : [nextProps.dataSource]);
            this.props.context.loadMissingData(this.props.queryParameter);
        }
    }

    getDataSourceIdFromProps(props) {
        const dS = props.allDatasources;
        if (Array.isArray(dS)) {
            const dsIds = dS.map((v) => v.getDataSourceIdentifier()).join();
            return dsIds;
        }
        else if (dS) {
            return dS.getDataSourceIdentifier();
        }
        else if (this.props.dataSource) {
            return this.props.dataSource.getDataSourceIdentifier();

        }
        else if (props.dataUrl) {
            return props.dataUrl;
        }
        return null;
    }

    getHeader = () => {

        //<button disabled={this.state.page === 0} onClick={this.handlePrefClicked} className="btn btn-success btn-sm prev_btn">{"\u25c4"}</button> : null}
        const pager = (this.state.page === 0 && !this.hasMoreElements() && !this.props.headerContent) ? null : <div style={{ marginLeft: "auto", marginRight: "5px" }}>
            {this.props.headerContent}
            {this.props.enablePagging ? <Button handleClick={this.handlePrefClicked} readOnly={this.state.page === 0} iconName={"arrow-left"} /> : null}
            {this.props.enablePagging ? <Button handleClick={this.handleNextClicked} readOnly={!this.hasMoreElements()} iconName={"arrow-right"} /> : null}
        </div>;
        const header = Helper.hasValue(this.props.title) ? <h3 style={{ padding: "10px 0px 10px 10px", margin: "0px", display: "inline-block", color: "white", fontSize: "16px", fontWeight: 400 }}>{this.props.titel}</h3> : null;
        return (<div style={{ color: "#fff", background: "#3c8dbc", backgroundColor: "#777", display: "flex", alignItems: "center" }}>
            {header}
            {pager}
        </div>)
    }

    render() {
        var header = this.getHeader();
        return (
            <div className="box box-solid box-primary">
                {header}
                <div className="box-body">
                    {this.props.children}
                </div>
            </div>
        );
    }
};

interface IKendoSimpleChart {
    height?: any;
    onDataBound?(chart: any);
    settings: any;
    onSeriesClick?(event: any);
    values?: any;
}

export class KendoSimpleChart extends React.Component<IKendoSimpleChart, any>{
    private kendoChart;

    constructor(props) {
        super(props);
        this.state = { values: [] };
    }

    handleDataBound = () => {
        this.props.onDataBound(this.kendoChart);
    }

    componentDidMount() {

        var $rootNode = $(this.refs.chart);
        if (this.props.settings) {
            var jsSettings = this.props.settings;

            if (this.props.onDataBound) {
                jsSettings.dataBound = this.handleDataBound;

            }
            var chart = $rootNode.kendoChart(jsSettings);
            this.kendoChart = chart.data("kendoChart");

            this.kendoChart.bind("seriesClick", this.seriesClick);

            if (this.props.values) {
                var dataSourceObj: any;
                dataSourceObj = {
                    data: this.props.values
                };

                var dataSource = new kendo.data.DataSource(dataSourceObj);
                this.kendoChart.setDataSource(dataSource);
            }
        } else {
            var chart = $rootNode.kendoChart({});
            this.kendoChart = chart.data("kendoChart");
        }

    }

    seriesClick = (e) => {

        if (this.props.onSeriesClick) {
            this.props.onSeriesClick(e);
        }
    }

    componentWillUnmount() {
        if (this.kendoChart) {
            this.kendoChart.destroy();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {

        return JSON.stringify(this.props.values) !== JSON.stringify(nextProps.values)
            || JSON.stringify(this.props.settings) !== JSON.stringify(nextProps.settings)
            || this.props.height != nextProps.height;
    }

    componentDidUpdate(prevProps, prevState) {

        var dataSourceObj: any;
        dataSourceObj = {
            data: this.props.values
        };

        var dataSource = new kendo.data.DataSource(dataSourceObj);

        if (this.props.settings !== prevProps.settings) {
            this.kendoChart.setOptions(this.props.settings);
            this.kendoChart.setDataSource(dataSource);
        }
        if (this.props.values !== prevProps.values) {
            try {
                this.kendoChart.setDataSource(dataSource);
                //Bug in Kendo UI CategoryAxis wird nicht gelöscht bei einer leeren Datenmenge
                if (this.props.values && this.props.values.length == 0) {
                    this.kendoChart.options.categoryAxis.categories = [];
                    this.kendoChart.refresh();
                }
            }
            catch (err) { }
        }
    }
    private onResize = () => {
        if (this.kendoChart) {
            this.kendoChart.redraw();
        }
    }

    render() {
        var chartHeight = this.props.height || "600px";
        return (<>
            <ResizeDetector handleWidth handleHeight onResize={this.onResize} />
            <div ref="chart" style={{ height: chartHeight, overflow: "hidden" }} />
        </>);
    }
};

export class SQLEditor extends React.Component<any, any>{

    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }

    handleChange = (newValue) => {
        this.props.onTextChange(this.props.settings.name, newValue);
    }

    render() {
        var style = { height: '500px' };
        return (<div style={style}><MonacoEditor code={this.props.values[this.props.settings.name]} language="sql" onTextChange={this.handleChange}></MonacoEditor></div>);
    }
};

export class SideBar extends React.Component<any, any>{

    handleValueChanged = (name, value) => {
        this.props.onValueChanged(name, value)
    }

    render() {
        var style = { height: "100%" };
        var divStyle: React.CSSProperties = {
            "overflowY": "auto",
            "overflowX": "hidden",
            top: "35px",
            bottom: "0px",
            left: "0px",
            right: "0px",
            position: "absolute"
        };
        return (<div className="sidebar">
            <div className="sidebar-container">
                <div style={style}>
                    <div className="sideBarHeader">{this.props.header} {this.props.headerContent}</div>
                    <div className="sidepane" style={divStyle}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        </div>
        );
    }
};
interface BasicDialogProps extends React.PropsWithChildren { onSave?, onClose, title: string, okayLabel?: string, width?: string, height?: number | string, dialogInternalRef?: (dialog: kendo.ui.Dialog) => void; }
export class BasicDialog extends React.Component<BasicDialogProps, any>{
    private dialogProps: DialogProps;

    constructor(props) {
        super(props);
        this.dialogProps = {
            title: props.title,
            actions: [
            ],
            afterClose: () => {
                props.onClose && props.onClose();
            },
            width: this.props.width || "65%",
            height: this.props.height,
            maxHeight: this.props.height,
            open: true,
            closable: true,
            dialogInternalRef: this.props.dialogInternalRef
        };

        if (props.onSave) {
            this.dialogProps.actions.push({
                label: props.okayLabel || "OK",
                action: () => {
                    this.handleSave();
                    return true;
                }
            });
        }

    }

    handleClose = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    handleSave = () => {
        if (this.props.onSave) {
            this.props.onSave();
        }
    }

    render() {
        return (<Dialog {...this.dialogProps}>
            {this.props.children}
        </Dialog>)
    }
};

export class KendoGrid extends React.Component<any, any>{
    private grid: any;
    private _gridElementRef;

    constructor(props) {
        super(props);
        this.state = { page: 0 };
    }

    componentDidMount() {

        const $rootNode = $(this._gridElementRef);
        const selectable: any = this.props.multiselect ? "multiple, row" : true;
        const config: any = {
            dataSource: {
                data: this.props.data
            },

            sortable: true,
            selectable: selectable,
            change: this.handleSelectionChange,
            columns: this.props.columns
        };

        if (typeof this.props.noheight === 'undefined' || !this.props.noheight) {
            config.height = 550;
        }

        if (this.props.filtermode) {
            config.filterable = { mode: this.props.filtermode };
        }
        this.grid = $rootNode.kendoGrid(config).data("kendoGrid");

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.data != prevProps.data) {
            this.grid.dataSource.data(this.props.data);
        }
    }

    handleSelectionChange = (e) => {
        const selectedItems = this.getSelectedItems();
        if (this.props.OnSelectedItemChanged) {
            if (this.props.multiselect) {
                this.props.OnSelectedItemChanged(selectedItems);
            }
            else {
                this.props.OnSelectedItemChanged(selectedItems[0]);
            }
        }
    }

    getSelectedItems() {
        const selected = this.grid.select();
        const selectedDataItems = [];
        if (selected) {
            for (var i = 0; i < selected.length; i++) {
                var dataItem = this.grid.dataItem(selected[i]);
                selectedDataItems.push(dataItem);
            }
        }
        return selectedDataItems;
    }

    componentWillUnmount() {
        kendo.destroy(this.grid.element);
    }

    render() {
        return (
            <FullHeightContainer onRef={(r) => this._gridElementRef = r}></FullHeightContainer>
        )
    }
};

export class KendoMaskedTextBox extends React.Component<any, any>{
    constructor(props) {
        super(props);
        this.state = { page: 0, isLoading: false };
    }

    componentDidMount() {
        var that = this;
        var $rootNode = $(this.refs.maskedTextBox);

        $rootNode.kendoMaskedTextBox({
            mask: this.props.mask,
            change: function () {
                var value = this.value();
                that.props.onTextChange(value);
            },
            value: this.props.value
        });
    }

    render() {
        var style = { width: "100%" };
        if (this.state.isLoading) {
            var spinner = <img src="Content/img/spinner.gif" />
        }
        return (
            <ReactColumn width={this.props.width}>
                <div className="form-group">
                    <label>{this.props.label}</label> {spinner}
                    <input ref="maskedTextBox" name={this.props.name} style={style}></input>
                </div>
            </ReactColumn>
        )
    }
};


export class KendoTreeView extends React.Component<any, any>{
    private treeView: any;

    constructor(props) {
        super(props);
        this.state = { page: 0, isLoading: false };
    }

    componentDidMount() {
        var params: any;

        params = {
            checkboxes: Boolean(this.props.checkboxes),
            select: this.props.onSelect,
            check: this.props.onCheck,
            change: this.props.onChange,
            collapse: this.props.onCollapse,
            expand: this.props.onExpand,
            dragAndDrop: Boolean(this.props.dragAndDrop),
            dragstart: this.props.onDragStart,
            drag: this.props.onDrag,
            drop: this.props.onDrop,
            dragend: this.props.onDragEnd,
            navigate: this.props.onNavigate
        };
        if (this.props.data != null) {
            params.dataSource = this.props.data;
        };
        if (this.props.dataTextField != null) {
            params.dataTextField = this.props.dataTextField;
        };
        if (this.props.template != null) {
            params.template = this.props.template;
        };

        var $rootNode = $(this.refs.treeView);
        var treeView = $rootNode.kendoTreeView(params);
        this.treeView = treeView.data("kendoTreeView");
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        var params: any;
        params = {
            checkboxes: Boolean(nextProps.checkboxes),
            dragAndDrop: Boolean(nextProps.dragAndDrop),
        };
        if (nextProps.dataTextField != null) {
            params.dataTextField = nextProps.dataTextField;
        };
        if (nextProps.template != null) {
            params.template = nextProps.template;
        };
        this.treeView.setOptions(params);
        if (nextProps.data) {
            this.treeView.setDataSource(nextProps.data);
        }
    }

    componentWillUnmount() {
        this.treeView.destroy();
    }

    render() {
        if (this.state.isLoading) {
            var spinner = <img src="Content/img/spinner.gif" />
        }
        return (<div style={{ height: "100%" }}><div ref="treeView" style={{ height: "100%" }}></div></div>)
    }
};

export const InnoButtonOkay = ({ label, onClick }) => {
    return (
        <div className="k-item innoBtnOK innoBtnContent innoBtnWrapper k-state-default" >
            <span className="k-link " onClick={onClick}>
                <div className="innoBtnContent">{label}</div>
            </span>
        </div >);

};

export const InnoButtonNew = ({ label, onClick }) => {
    return (
        <div className="k-item innoBtnNew innoBtnContent innoBtnWrapper k-state-default" >
            <span className="k-link " onClick={onClick}>
                <div className="innoBtnContent">{label}</div>
            </span>
        </div>);
};

export class InnoButtonDelete extends React.Component<any, any>{
    handleButtonClicked = () => {
        this.props.onClick();
    }

    render() {
        var divStyle: React.CSSProperties = {
            position: "absolute",
            height: "100%",
            width: "100%",
            zIndex: 1,
            backgroundColor: "#ddd",
            opacity: 0.3,
            display: this.props.disabled ? 'block' : 'none'
        }
        return (
            <div className="k-item innoBtnDelete innoBtnContent innoBtnWrapper k-state-default" >
                <div style={divStyle}></div>
                <span className="k-link " onClick={this.handleButtonClicked}>
                    <div className="innoBtnContent">{this.props.label}</div>
                </span>
            </div>);
    }
};

export class InnoButtonCancel extends React.Component<any, any>{
    handleButtonClicked = () => {
        this.props.onClick();
    }

    render() {
        return (
            <div className="k-item innoBtnBack innoBtnContent innoBtnWrapper k-state-default" >
                <span className="k-link " onClick={this.handleButtonClicked}>
                    <div className="innoBtnContent">{this.props.label}</div>
                </span>
            </div>);
    }
};

export class InnoButtonCustom extends React.Component<any, any>{
    handleButtonClicked = () => {
        this.props.onClick();
    }

    render() {
        var divStyle: React.CSSProperties = {
            position: "absolute",
            height: "100%",
            width: "100%",
            zIndex: 1,
            backgroundColor: "#ddd",
            opacity: 0.3,
            display: this.props.disabled ? 'block' : 'none'
        }
        return (
            <div className="k-item innoBtnCustom innoBtnContent innoBtnWrapper k-state-default">
                <div style={divStyle}></div>
                <span className="k-link " onClick={this.handleButtonClicked}>
                    <div className="innoBtnContent">{this.props.label}</div>
                </span>
            </div>);
    }
};

export class InnoButtonPrint extends React.Component<any, any>{
    handleButtonClicked = () => {
        this.props.onClick();
    }

    render() {
        return (
            <div className="k-item innoBtnPrint innoBtnContent innoBtnWrapper k-state-default" >
                <span className="k-link " onClick={this.handleButtonClicked}>
                    <div className="innoBtnContent">{this.props.label}</div>
                </span>
            </div>);
    }
};



export class TruncatedLabel extends React.Component<any, any>{
    render() {
        return <label style={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer", fontFamily: "roboto" }}>{this.props.children}</label>
    }
}